type Selector<T> = (value: T) => unknown;

export function uniqueBy<T>(selector: Selector<T>, values: T[]): T[] {
  const keys = new Set();
  const unique = [];
  for (const value of values) {
    const key = selector(value);
    if (!keys.has(key)) {
      keys.add(key);
      unique.push(value);
    }
  }
  return unique;
}
